(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessory-upsell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initEntrance(sectionEl) {
      if (sectionEl.getAttribute('data-au-animated') !== 'true') return;

      var targets = sectionEl.querySelectorAll('[data-au-enter]');
      if (!targets.length) return;

      var duration = getComputedStyle(sectionEl).getPropertyValue('--au-enter-duration').trim() || '400ms';

      targets.forEach(function (el) {
        el.style.setProperty('--enter-delay', el.getAttribute('data-au-enter') || '0');
        el.style.setProperty('--au-enter-duration', duration);
      });

      if (sectionEl._auObserver) {
        sectionEl._auObserver.disconnect();
        sectionEl._auObserver = null;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );

      targets.forEach(function (el) {
        observer.observe(el);
      });

      sectionEl._auObserver = observer;
    }

    function initSection(sectionEl) {
      initEntrance(sectionEl);
    }

    function initAll() {
      document.querySelectorAll('.accessory-upsell[data-section-id]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var el = document.querySelector(
        '.accessory-upsell[data-section-id="' + e.detail.sectionId + '"]'
      );
      if (el) initSection(el);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var el = document.querySelector(
        '.accessory-upsell[data-section-id="' + e.detail.sectionId + '"]'
      );
      if (el && el._auObserver) {
        el._auObserver.disconnect();
        el._auObserver = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-event-promotion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initEntrance(sectionEl) {
      var root = sectionEl.closest('.pdp-evt');
      if (!root) return;
      var targets = root.querySelectorAll('[data-evt-enter]');
      if (!targets.length) return;

      var stagger = getComputedStyle(root).getPropertyValue('--evt-stagger-ms').trim() || '80ms';
      root.style.setProperty('--evt-stagger-ms', stagger);

      targets.forEach(function (el) {
        var d = el.dataset.evtEnter != null ? el.dataset.evtEnter : '0';
        el.style.setProperty('--enter-delay', d);
      });

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );

      targets.forEach(function (el) {
        observer.observe(el);
      });
    }

    function initSection(sectionEl) {
      initEntrance(sectionEl);
    }

    function init() {
      document.querySelectorAll('.pdp-evt[data-section-id]').forEach(function (el) {
        initSection(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var sectionEl = document.querySelector('.pdp-evt[data-section-id="' + e.detail.sectionId + '"]');
      if (sectionEl) initSection(sectionEl);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-highlights"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initEntrance(sectionEl) {
      var targets = sectionEl.querySelectorAll('[data-ph-enter]');
      if (!targets.length) return;

      var duration = getComputedStyle(sectionEl).getPropertyValue('--ph-enter-duration').trim();
      if (!duration) duration = '350ms';

      targets.forEach(function (el) {
        el.style.setProperty('--enter-delay', el.dataset.phEnter || '0');
        el.style.setProperty('--ph-enter-duration', duration);
      });

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -48px 0px' }
      );

      targets.forEach(function (el) {
        observer.observe(el);
      });
    }

    function initSection(sectionEl) {
      initEntrance(sectionEl);
    }

    function init() {
      document.querySelectorAll('.ph[data-section-id]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var sectionEl = document.querySelector('.ph[data-section-id="' + e.detail.sectionId + '"]');
      if (sectionEl) initSection(sectionEl);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initEntrance(sectionEl) {
      if (sectionEl.getAttribute('data-pl-animated') !== 'true') return;

      var targets = sectionEl.querySelectorAll('[data-pl-enter]');
      if (!targets.length) return;

      if (sectionEl._plObserver) {
        sectionEl._plObserver.disconnect();
        sectionEl._plObserver = null;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );

      targets.forEach(function (el) {
        observer.observe(el);
      });

      sectionEl._plObserver = observer;
    }

    function forceVisible(sectionEl) {
      sectionEl.querySelectorAll('[data-pl-enter]').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    function initAll() {
      document.querySelectorAll('.section-resource-list[data-section-id]').forEach(initEntrance);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var el = document.querySelector(
        '.section-resource-list[data-section-id="' + e.detail.sectionId + '"]'
      );
      if (el) initEntrance(el);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var el = document.querySelector(
        '.section-resource-list[data-section-id="' + e.detail.sectionId + '"]'
      );
      if (el && el._plObserver) {
        el._plObserver.disconnect();
        el._plObserver = null;
      }
    });

    document.addEventListener('shopify:section:select', function (e) {
      var el = document.querySelector(
        '.section-resource-list[data-section-id="' + e.detail.sectionId + '"]'
      );
      if (el) forceVisible(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tatc-editorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function revealPageLoad(root) {
      if (!root || root.getAttribute('data-tatc-editorial-anim') !== 'on') return;
      if (root.getAttribute('data-tatc-editorial-trigger') !== 'page-load') return;
      root.querySelectorAll('.animate-on-scroll').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    function initAll() {
      document.querySelectorAll('[data-tatc-editorial-root]').forEach(revealPageLoad);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-tatc-editorial-root]');
      if (root) revealPageLoad(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tatc-events-calendar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    var MONTHS = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    var MOBILE_BREAKPOINT = 768;
    var DESKTOP_GRID_BREAKPOINT = 990;
    var MOBILE_DAYS = 7;
    var BREAK_NEUTRAL_ACCENT = 'rgb(var(--color-foreground-rgb) / 0.55)';

    function getYoutubeSvg(size) {
      var s = size || 24;
      return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
        '<path d="M18.16 5.87c.34 1.309.34 4.08.34 4.08s0 2.771-.34 4.08a2.125 2.125 0 0 1-1.53 1.53c-1.309.34-6.63.34-6.63.34s-5.321 0-6.63-.34a2.125 2.125 0 0 1-1.53-1.53c-.34-1.309-.34-4.08-.34-4.08s0-2.771.34-4.08a2.173 2.173 0 0 1 1.53-1.53C4.679 4 10 4 10 4s5.321 0 6.63.34a2.173 2.173 0 0 1 1.53 1.53ZM8.3 12.5l4.42-2.55L8.3 7.4v5.1Z"/>' +
        '</svg>';
    }

    function getWhatnotSvg(size) {
      var s = size || 24;
      return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
        '<path d="M4 4h7.5l2 4.5L16 4H20l-5.5 8L20 20h-4l-2.5-4.5L11 20H4l5.5-8L4 4z"/>' +
        '</svg>';
    }

    function parseJsonScript(id, fallback) {
      var el = document.getElementById(id);
      if (!el || !el.textContent) return fallback !== undefined ? fallback : [];
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return fallback !== undefined ? fallback : [];
      }
    }

    function formatDateKey(date) {
      var y = date.getFullYear();
      var m = String(date.getMonth() + 1).padStart(2, '0');
      var d = String(date.getDate()).padStart(2, '0');
      return y + '-' + m + '-' + d;
    }

    function parseDateKey(key) {
      var parts = key.split('-');
      return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    }

    function addDaysToDateKey(dateKey, days) {
      var date = parseDateKey(dateKey);
      date.setDate(date.getDate() + days);
      return formatDateKey(date);
    }

    function toIcsDateValue(dateKey) {
      return String(dateKey || '').replace(/-/g, '');
    }

    function escapeIcsText(text) {
      return String(text || '')
        .replace(/\\/g, '\\\\')
        .replace(/;/g, '\\;')
        .replace(/,/g, '\\,')
        .replace(/\r\n|\n|\r/g, '\\n');
    }

    function getWeekday(date) {
      return WEEKDAYS[date.getDay()];
    }

    function startOfDay(date) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function debounce(fn, wait) {
      var timer;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(fn, wait);
      };
    }

    function isMobileViewport() {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }

    function supportsGridView() {
      return window.innerWidth >= DESKTOP_GRID_BREAKPOINT;
    }

    function closestFromEvent(e, selector) {
      var el = e.target;
      if (!el) return null;
      if (el.nodeType === 3) el = el.parentElement;
      return el && typeof el.closest === 'function' ? el.closest(selector) : null;
    }

    function getWeekStartSunday(date) {
      var d = startOfDay(date);
      d.setDate(d.getDate() - d.getDay());
      return d;
    }

    function TatcEventsCalendar(root) {
      this.root = root;
      this.sectionId = root.getAttribute('data-section-id');
      this.recurring = parseJsonScript('tatc-ec-data-recurring-' + this.sectionId);
      this.special = parseJsonScript('tatc-ec-data-special-' + this.sectionId);
      this.closed = parseJsonScript('tatc-ec-data-closed-' + this.sectionId);
      this.breaks = parseJsonScript('tatc-ec-data-breaks-' + this.sectionId);
      this.cardShows = parseJsonScript('tatc-ec-data-card-shows-' + this.sectionId);
      this.i18n = parseJsonScript('tatc-ec-i18n-' + this.sectionId, {});

      this.today = startOfDay(new Date());
      this.year = this.today.getFullYear();
      this.month = this.today.getMonth();
      this.filter = 'all';
      this.mobileFilter = 'all';
      this.mobileWeekOffset = 0;
      this.view = 'grid';
      this.isMobile = isMobileViewport();
      this._hasRendered = false;

      this.maxEventsPerCell = parseInt(root.getAttribute('data-max-events-per-cell'), 10) || 3;
      this.showFilterBar = root.getAttribute('data-show-filter-bar') === 'true';
      this.showLegend = root.getAttribute('data-show-legend') === 'true';

      this.closedMap = {};
      this.closed.forEach(function (c) {
        if (c.date) this.closedMap[c.date] = c;
      }, this);

      this.maxViewDate = new Date(this.today.getFullYear(), this.today.getMonth() + 12, 1);

      this.els = {
        monthLabel: root.querySelector('[data-tatc-ec-month-label]'),
        prevBtn: root.querySelector('[data-tatc-ec-prev]'),
        nextBtn: root.querySelector('[data-tatc-ec-next]'),
        todayBtn: root.querySelector('[data-tatc-ec-today]'),
        days: root.querySelector('[data-tatc-ec-days]'),
        filters: root.querySelector('[data-tatc-ec-filters]'),
        legend: root.querySelector('[data-tatc-ec-legend]'),
        gridView: root.querySelector('[data-tatc-ec-grid-view]'),
        listView: root.querySelector('[data-tatc-ec-list-view]'),
        mobileAgenda: root.querySelector('[data-tatc-ec-mobile-agenda]'),
        mobileToolbar: root.querySelector('.tatc-ec__mobile-toolbar'),
        mobileWeekNav: root.querySelector('[data-tatc-ec-mobile-week-nav]'),
        mobileWeekNavInner: root.querySelector('[data-tatc-ec-mobile-week-nav-inner]'),
        mobileFilters: root.querySelector('[data-tatc-ec-mobile-filters]'),
        viewBtns: root.querySelectorAll('[data-tatc-ec-view]'),
        modal: document.querySelector('[data-tatc-ec-modal][data-section-id="' + this.sectionId + '"]'),
        modalDate: null,
        modalCount: null,
        modalBody: null,
        modalClose: null
      };

      if (this.els.modal) {
        this.els.modalDate = this.els.modal.querySelector('[data-tatc-ec-modal-date]');
        this.els.modalCount = this.els.modal.querySelector('[data-tatc-ec-modal-count]');
        this.els.modalBody = this.els.modal.querySelector('[data-tatc-ec-modal-body]');
        this.els.modalClose = this.els.modal.querySelector('[data-tatc-ec-modal-close]');
        if (this.els.modal.parentElement !== document.body) {
          document.body.appendChild(this.els.modal);
        }
      }

      this._abortController = new AbortController();
      var self = this;
      this._onResize = debounce(function () {
        var wasMobile = self.isMobile;
        var wasGridSupported = supportsGridView();
        self.isMobile = isMobileViewport();
        var isGridSupported = supportsGridView();
        if (wasMobile !== self.isMobile || wasGridSupported !== isGridSupported) {
          self.updateViewAttribute();
          self.render();
        }
      }, 150);
      window.addEventListener('resize', this._onResize);

      this.bindEvents();
      this.updateViewAttribute();
      this.render();
      this.initAnimations();
    }

    TatcEventsCalendar.prototype.bindEvents = function () {
      var self = this;
      var signal = this._abortController ? this._abortController.signal : undefined;
      var listenOpts = signal ? { signal: signal } : undefined;

      if (this.els.prevBtn) {
        this.els.prevBtn.addEventListener('click', function () {
          if (!self.canGoPrev()) return;
          if (self.month === 0) {
            self.month = 11;
            self.year--;
          } else {
            self.month--;
          }
          self.render();
        }, listenOpts);
      }

      if (this.els.nextBtn) {
        this.els.nextBtn.addEventListener('click', function () {
          if (!self.canGoNext()) return;
          if (self.month === 11) {
            self.month = 0;
            self.year++;
          } else {
            self.month++;
          }
          self.render();
        }, listenOpts);
      }

      if (this.els.todayBtn) {
        this.els.todayBtn.addEventListener('click', function () {
          self.year = self.today.getFullYear();
          self.month = self.today.getMonth();
          self.render();
        }, listenOpts);
      }

      this.els.viewBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var nextView = btn.getAttribute('data-tatc-ec-view');
          if (nextView === 'grid' && !supportsGridView()) return;
          self.view = nextView;
          self.updateViewAttribute();
          self.render();
        }, listenOpts);
      });

      if (this.els.modalClose) {
        this.els.modalClose.addEventListener('click', function () {
          self.closeModal();
        }, listenOpts);
      }

      if (this.els.modal) {
        this.els.modal.addEventListener('click', function (e) {
          var panel = self.els.modal.querySelector('.tatc-ec__modal-panel');
          if (e.target === self.els.modal || (panel && !panel.contains(e.target))) {
            self.closeModal();
          }
        }, listenOpts);
        this.els.modal.addEventListener('cancel', function (e) {
          e.preventDefault();
          self.closeModal();
        }, listenOpts);
      }

      if (this.els.mobileWeekNav) {
        this.els.mobileWeekNav.addEventListener('click', function (e) {
          if (closestFromEvent(e, '[data-tatc-ec-mobile-this-week]')) {
            e.preventDefault();
            self.resetMobileWeek();
            return;
          }
          if (closestFromEvent(e, '[data-tatc-ec-mobile-prev]')) {
            if (!self.canGoMobilePrevWeek()) return;
            self.mobileWeekOffset--;
            self.render();
            return;
          }
          if (closestFromEvent(e, '[data-tatc-ec-mobile-next]')) {
            if (!self.canGoMobileNextWeek()) return;
            self.mobileWeekOffset++;
            self.render();
          }
        }, listenOpts);
      }

      if (this.els.mobileFilters) {
        this.els.mobileFilters.addEventListener('click', function (e) {
          var btn = closestFromEvent(e, '[data-tatc-ec-mobile-filter]');
          if (!btn) return;
          self.mobileFilter = btn.getAttribute('data-tatc-ec-mobile-filter');
          self.render();
        }, listenOpts);
      }

      this._onAddToCalendarClick = function (e) {
        var addCalBtn = closestFromEvent(e, '[data-tatc-ec-add-cal]');
        if (!addCalBtn) return;
        e.preventDefault();
        e.stopPropagation();
        var eventId = addCalBtn.getAttribute('data-event-id');
        var dateKey = addCalBtn.getAttribute('data-date');
        var event = self.findEventById(eventId);
        if (event) self.downloadIcs(event, dateKey);
      };

      this.root.addEventListener('click', this._onAddToCalendarClick, listenOpts);
      // Modal is appended to document.body, so it is outside this.root
      if (this.els.modal) {
        this.els.modal.addEventListener('click', this._onAddToCalendarClick, listenOpts);
      }
    };

    TatcEventsCalendar.prototype.canGoPrev = function () {
      return this.year > this.today.getFullYear() ||
        (this.year === this.today.getFullYear() && this.month > this.today.getMonth());
    };

    TatcEventsCalendar.prototype.canGoNext = function () {
      var viewing = new Date(this.year, this.month, 1);
      return viewing < this.maxViewDate;
    };

    TatcEventsCalendar.prototype.getActiveView = function () {
      if (this.isMobile) return 'list';
      return supportsGridView() && this.view === 'grid' ? 'grid' : 'list';
    };

    TatcEventsCalendar.prototype.updateViewAttribute = function () {
      var activeView = this.getActiveView();
      this.root.setAttribute('data-tatc-ec-view', activeView);
      this.root.setAttribute('data-tatc-ec-grid-supported', supportsGridView() ? 'true' : 'false');
      this.els.viewBtns.forEach(function (btn) {
        var isActive = btn.getAttribute('data-tatc-ec-view') === activeView;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }, this);

      if (activeView === 'list') {
        this.els.listView.removeAttribute('hidden');
      } else {
        this.els.listView.setAttribute('hidden', '');
      }
    };

    TatcEventsCalendar.prototype.isSpecialOnDate = function (event, dateKey) {
      if (!event.isActive || !event.startDate) return false;
      var end = event.endDate || event.startDate;
      return dateKey >= event.startDate && dateKey <= end;
    };

    TatcEventsCalendar.prototype.getRawEventsForDate = function (dateKey) {
      var closed = this.closedMap[dateKey];
      var events = [];
      var self = this;

      this.special.forEach(function (e) {
        if (self.isSpecialOnDate(e, dateKey)) {
          events.push(Object.assign({}, e, { eventType: 'special' }));
        }
      });

      if (!closed) {
        var weekday = getWeekday(parseDateKey(dateKey));
        this.recurring.forEach(function (e) {
          if (e.isActive && e.dayOfWeek === weekday) {
            events.push(Object.assign({}, e, { eventType: 'recurring' }));
          }
        });

        this.breaks.forEach(function (e) {
          if (e.isActive && e.dayOfWeek === weekday) {
            events.push(Object.assign({}, e, { eventType: 'break' }));
          }
        });
      }

      this.cardShows.forEach(function (e) {
        if (self.isSpecialOnDate(e, dateKey)) {
          events.push(Object.assign({}, e, { eventType: 'card_show' }));
        }
      });

      return { closed: closed || null, events: events };
    };

    TatcEventsCalendar.prototype.applyFilter = function (events) {
      var self = this;
      if (this.filter === 'all') return events;
      if (this.filter === 'special') {
        return events.filter(function (e) { return e.eventType === 'special'; });
      }
      if (this.filter === 'breaks') {
        return events.filter(function (e) { return e.eventType === 'break'; });
      }
      if (this.filter === 'card_shows') {
        return events.filter(function (e) { return e.eventType === 'card_show'; });
      }
      if (this.filter === 'recurring') {
        return events.filter(function (e) { return e.eventType === 'recurring'; });
      }
      if (this.filter === 'community') {
        return events.filter(function (e) {
          return e.eventType !== 'break' && e.eventType !== 'card_show' && !e.tcg;
        });
      }
      return events.filter(function (e) {
        return e.tcg && e.tcg.slug === self.filter;
      });
    };

    TatcEventsCalendar.prototype.applyMobileFilter = function (events) {
      if (this.mobileFilter === 'all') return events;
      if (this.mobileFilter === 'special') {
        return events.filter(function (e) { return e.eventType === 'special'; });
      }
      if (this.mobileFilter === 'recurring') {
        return events.filter(function (e) { return e.eventType === 'recurring'; });
      }
      return events;
    };

    TatcEventsCalendar.prototype.getMobileWeekStart = function (offset) {
      var start = getWeekStartSunday(this.today);
      start.setDate(start.getDate() + (offset || 0) * 7);
      return start;
    };

    TatcEventsCalendar.prototype.canGoMobilePrevWeek = function () {
      return this.mobileWeekOffset > 0;
    };

    TatcEventsCalendar.prototype.canGoMobileNextWeek = function () {
      var nextWeekStart = this.getMobileWeekStart(this.mobileWeekOffset + 1);
      return nextWeekStart < this.maxViewDate;
    };

    TatcEventsCalendar.prototype.refreshToday = function () {
      this.today = startOfDay(new Date());
      this.maxViewDate = new Date(this.today.getFullYear(), this.today.getMonth() + 12, 1);
    };

    TatcEventsCalendar.prototype.resetMobileWeek = function () {
      this.refreshToday();
      this.mobileWeekOffset = 0;
      this.render();
      if (this.els.mobileToolbar) {
        this.els.mobileToolbar.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    };

    TatcEventsCalendar.prototype.getMobileWeekDates = function () {
      var weekStart = this.getMobileWeekStart(this.mobileWeekOffset);
      var dates = [];

      for (var i = 0; i < MOBILE_DAYS; i++) {
        var date = new Date(weekStart);
        date.setDate(date.getDate() + i);
        if (this.mobileWeekOffset === 0 && date < this.today) continue;
        dates.push(date);
      }

      return dates;
    };

    TatcEventsCalendar.prototype.formatWeekRange = function (weekStart, weekEnd) {
      var startLabel = weekStart.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
      var endLabel = weekEnd.toLocaleDateString(undefined, {
        month: 'short', day: 'numeric', year: 'numeric'
      });
      return startLabel + ' \u2013 ' + endLabel;
    };

    TatcEventsCalendar.prototype.getMobileFilterCounts = function () {
      var counts = { all: 0, recurring: 0, special: 0 };
      var self = this;

      this.getMobileWeekDates().forEach(function (date) {
        var key = formatDateKey(date);
        var raw = self.getRawEventsForDate(key);
        raw.events.forEach(function (e) {
          counts.all++;
          if (e.eventType === 'special') {
            counts.special++;
          } else if (e.eventType === 'recurring') {
            counts.recurring++;
          }
        });
      });

      return counts;
    };

    TatcEventsCalendar.prototype.renderMobileWeekNav = function () {
      if (!this.els.mobileWeekNavInner) return;

      var weekStart = this.getMobileWeekStart(this.mobileWeekOffset);
      var weekEnd = new Date(weekStart);
      weekEnd.setDate(weekEnd.getDate() + 6);
      var rangeLabel = this.formatWeekRange(weekStart, weekEnd);
      var html = '';

      html += '<div class="tatc-ec__mobile-week-nav-row">';
      html += '<button type="button" class="tatc-ec__nav-btn" data-tatc-ec-mobile-prev aria-label="' +
        this.escapeHtml(this.i18n.prevWeek || 'Previous week') + '"' +
        (this.canGoMobilePrevWeek() ? '' : ' disabled') + '>' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></button>';

      html += '<div class="tatc-ec__mobile-week-label">';
      if (this.mobileWeekOffset === 0) {
        html += '<p class="tatc-ec__mobile-week-label-primary">' +
          this.escapeHtml(this.i18n.thisWeek || 'This week') + '</p>';
      }
      html += '<p class="tatc-ec__mobile-week-label-range">' + this.escapeHtml(rangeLabel) + '</p>';
      html += '</div>';

      html += '<button type="button" class="tatc-ec__nav-btn" data-tatc-ec-mobile-next aria-label="' +
        this.escapeHtml(this.i18n.nextWeek || 'Next week') + '"' +
        (this.canGoMobileNextWeek() ? '' : ' disabled') + '>' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg></button>';
      html += '</div>';

      if (this.mobileWeekOffset > 0) {
        html += '<button type="button" class="tatc-ec__today-btn tatc-ec-type--label tatc-ec__mobile-this-week-btn" data-tatc-ec-mobile-this-week>' +
          this.escapeHtml(this.i18n.thisWeek || 'This week') + '</button>';
      }

      this.els.mobileWeekNavInner.innerHTML = html;
    };

    TatcEventsCalendar.prototype.renderMobileFilters = function () {
      if (!this.els.mobileFilters) return;

      var counts = this.getMobileFilterCounts();
      var self = this;
      var html = '';

      html += '<button type="button" class="tatc-ec__filter-btn" data-tatc-ec-mobile-filter="all" aria-pressed="' +
        (this.mobileFilter === 'all' ? 'true' : 'false') + '">' +
        this.escapeHtml(this.i18n.allEvents || 'All Events') + ' (' + counts.all + ')</button>';

      html += '<button type="button" class="tatc-ec__filter-btn" data-tatc-ec-mobile-filter="recurring" aria-pressed="' +
        (this.mobileFilter === 'recurring' ? 'true' : 'false') + '">' +
        this.escapeHtml(this.i18n.recurringEvents || 'Recurring') + ' (' + counts.recurring + ')</button>';

      html += '<button type="button" class="tatc-ec__filter-btn" data-tatc-ec-mobile-filter="special" aria-pressed="' +
        (this.mobileFilter === 'special' ? 'true' : 'false') + '">' +
        this.escapeHtml(this.i18n.specialEvents || 'Special Events') + ' (' + counts.special + ')</button>';

      this.els.mobileFilters.innerHTML = html;
    };

    TatcEventsCalendar.prototype.getEventsForDate = function (dateKey, applyFilter) {
      var data = this.getRawEventsForDate(dateKey);
      var events = applyFilter !== false ? this.applyFilter(data.events) : data.events;
      return { closed: data.closed, events: events };
    };

    TatcEventsCalendar.prototype.getFilterCounts = function () {
      var counts = { all: 0, special: 0, breaks: 0, cardShows: 0, community: 0, tcg: {} };
      var todayKey = formatDateKey(this.today);
      var daysInMonth = new Date(this.year, this.month + 1, 0).getDate();
      var self = this;

      for (var d = 1; d <= daysInMonth; d++) {
        var date = new Date(this.year, this.month, d);
        var key = formatDateKey(date);
        if (key < todayKey) continue;

        var raw = this.getRawEventsForDate(key);
        raw.events.forEach(function (e) {
          counts.all++;
          if (e.eventType === 'special') counts.special++;
          if (e.eventType === 'break') counts.breaks++;
          if (e.eventType === 'card_show') counts.cardShows++;
          if (e.eventType !== 'break' && e.eventType !== 'card_show' && !e.tcg) {
            counts.community++;
          } else if (e.tcg) {
            var slug = e.tcg.slug;
            counts.tcg[slug] = (counts.tcg[slug] || 0) + 1;
          }
        });
      }
      return counts;
    };

    TatcEventsCalendar.prototype.getLegendTcgs = function () {
      var map = {};
      var todayKey = formatDateKey(this.today);
      var daysInMonth = new Date(this.year, this.month + 1, 0).getDate();
      var self = this;

      for (var d = 1; d <= daysInMonth; d++) {
        var date = new Date(this.year, this.month, d);
        var key = formatDateKey(date);
        if (key < todayKey) continue;

        var raw = this.getRawEventsForDate(key);
        raw.events.forEach(function (e) {
          if (e.tcg && e.tcg.slug) {
            map[e.tcg.slug] = e.tcg;
          }
        });
      }
      return Object.values(map);
    };

    TatcEventsCalendar.prototype.getUniqueTcgFilters = function () {
      var map = {};
      var self = this;

      this.recurring.concat(this.special).forEach(function (e) {
        if (e.isActive && e.tcg && e.tcg.slug) {
          map[e.tcg.slug] = e.tcg;
        }
      });

      return Object.values(map).sort(function (a, b) {
        return (a.name || '').localeCompare(b.name || '');
      });
    };

    TatcEventsCalendar.prototype.renderFilters = function () {
      if (!this.showFilterBar || !this.els.filters) return;

      var counts = this.getFilterCounts();
      var tcgs = this.getUniqueTcgFilters();
      var self = this;
      var html = '';

      html += '<button type="button" class="tatc-ec__filter-btn" data-tatc-ec-filter="all" aria-pressed="' +
        (this.filter === 'all' ? 'true' : 'false') + '">' +
        this.i18n.allEvents + ' (' + counts.all + ')</button>';

      tcgs.forEach(function (tcg) {
        var count = counts.tcg[tcg.slug] || 0;
        var dotStyle = tcg.color ? ' style="background-color:' + tcg.color + '"' : '';
        html += '<button type="button" class="tatc-ec__filter-btn" data-tatc-ec-filter="' + tcg.slug +
          '" aria-pressed="' + (self.filter === tcg.slug ? 'true' : 'false') + '">' +
          '<span class="tatc-ec__filter-dot"' + dotStyle + '></span>' +
          (tcg.name || tcg.slug) + ' (' + count + ')</button>';
      });

      html += '<button type="button" class="tatc-ec__filter-btn" data-tatc-ec-filter="special" aria-pressed="' +
        (this.filter === 'special' ? 'true' : 'false') + '">' +
        this.i18n.specialEvents + ' (' + counts.special + ')</button>';

      html += '<button type="button" class="tatc-ec__filter-btn" data-tatc-ec-filter="breaks" aria-pressed="' +
        (this.filter === 'breaks' ? 'true' : 'false') + '">' +
        this.i18n.breaks + ' (' + counts.breaks + ')</button>';

      html += '<button type="button" class="tatc-ec__filter-btn" data-tatc-ec-filter="card_shows" aria-pressed="' +
        (this.filter === 'card_shows' ? 'true' : 'false') + '">' +
        this.i18n.cardShows + ' (' + counts.cardShows + ')</button>';

      html += '<button type="button" class="tatc-ec__filter-btn" data-tatc-ec-filter="community" aria-pressed="' +
        (this.filter === 'community' ? 'true' : 'false') + '">' +
        this.i18n.community + ' (' + counts.community + ')</button>';

      this.els.filters.innerHTML = html;

      this.els.filters.querySelectorAll('[data-tatc-ec-filter]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.filter = btn.getAttribute('data-tatc-ec-filter');
          self.render();
        });
      });
    };

    TatcEventsCalendar.prototype.getBreakLegendColor = function () {
      for (var i = 0; i < this.breaks.length; i++) {
        var b = this.breaks[i];
        if (b.isActive && b.color) return b.color;
      }
      return BREAK_NEUTRAL_ACCENT;
    };

    TatcEventsCalendar.prototype.hasActiveBreaks = function () {
      for (var i = 0; i < this.breaks.length; i++) {
        if (this.breaks[i].isActive) return true;
      }
      return false;
    };

    TatcEventsCalendar.prototype.getCardShowLegendColor = function () {
      for (var i = 0; i < this.cardShows.length; i++) {
        var c = this.cardShows[i];
        if (c.isActive && c.color) return c.color;
      }
      return 'var(--color-primary)';
    };

    TatcEventsCalendar.prototype.hasActiveCardShows = function () {
      for (var i = 0; i < this.cardShows.length; i++) {
        if (this.cardShows[i].isActive) return true;
      }
      return false;
    };

    TatcEventsCalendar.prototype.renderLegend = function () {
      if (!this.showLegend || !this.els.legend) return;

      var tcgs = this.getLegendTcgs();
      var hasBreaks = this.hasActiveBreaks();
      var html = '';

      tcgs.forEach(function (tcg) {
        var dotStyle = tcg.color ? ' style="background-color:' + tcg.color + '"' : '';
        html += '<span class="tatc-ec__legend-item"><span class="tatc-ec__legend-dot"' + dotStyle +
          '></span>' + (tcg.name || tcg.slug) + '</span>';
      });

      if (hasBreaks) {
        var breakColor = this.getBreakLegendColor();
        var breakDotStyle = breakColor ? ' style="background-color:' + breakColor + '"' : '';
        html += '<span class="tatc-ec__legend-item"><span class="tatc-ec__legend-dot"' + breakDotStyle +
          '></span>' + this.escapeHtml(this.i18n.breaks || 'Breaks') + '</span>';
      }

      if (this.hasActiveCardShows()) {
        var cardShowColor = this.getCardShowLegendColor();
        var cardShowDotStyle = cardShowColor ? ' style="background-color:' + cardShowColor + '"' : '';
        html += '<span class="tatc-ec__legend-item"><span class="tatc-ec__legend-dot"' + cardShowDotStyle +
          '></span>' + this.escapeHtml(this.i18n.cardShows || 'Card Shows') + '</span>';
      }

      this.els.legend.innerHTML = html;
      this.els.legend.hidden = tcgs.length === 0 && !hasBreaks && !this.hasActiveCardShows();
    };

    TatcEventsCalendar.prototype.renderGrid = function () {
      if (!this.els.days) return;

      var firstDay = new Date(this.year, this.month, 1);
      var startOffset = firstDay.getDay();
      var daysInMonth = new Date(this.year, this.month + 1, 0).getDate();
      var prevMonthDays = new Date(this.year, this.month, 0).getDate();
      var todayKey = formatDateKey(this.today);
      var self = this;
      var html = '';
      var cellIndex = 0;

      for (var i = 0; i < startOffset; i++) {
        var overflowDay = prevMonthDays - startOffset + i + 1;
        html += '<div class="tatc-ec__day tatc-ec__day--overflow" role="gridcell" aria-hidden="true">' +
          '<span class="tatc-ec__day-num">' + overflowDay + '</span></div>';
        cellIndex++;
      }

      for (var d = 1; d <= daysInMonth; d++) {
        var date = new Date(this.year, this.month, d);
        var key = formatDateKey(date);
        var data = this.getEventsForDate(key);
        var classes = ['tatc-ec__day'];

        if (key === todayKey) classes.push('tatc-ec__day--today');
        if (key < todayKey) classes.push('tatc-ec__day--past');
        if (data.closed) classes.push('tatc-ec__day--closed');

        html += '<div class="' + classes.join(' ') + '" role="gridcell" data-date="' + key + '">';
        html += '<span class="tatc-ec__day-num">' + d + '</span>';
        html += '<div class="tatc-ec__day-events">';

        if (data.closed && data.events.length === 0) {
          var closedLabel = this.i18n.closed;
          if (data.closed.reason) {
            closedLabel = this.i18n.closedReason.replace('%reason%', data.closed.reason);
          }
          html += '<span class="tatc-ec__chip tatc-ec__chip--closed" title="' +
            (data.closed.reason || '') + '">' + closedLabel + '</span>';
        } else if (data.closed && data.events.length > 0) {
          var closedTip = data.closed.reason ? ' title="' + data.closed.reason + '"' : '';
          html += '<span class="tatc-ec__chip tatc-ec__chip--closed"' + closedTip + '>' +
            this.i18n.closed + '</span>';
        }

        var visibleEvents = data.events.slice(0, this.maxEventsPerCell);
        visibleEvents.forEach(function (e) {
          html += self.renderChip(e, key);
        });

        if (data.events.length > this.maxEventsPerCell) {
          var more = data.events.length - this.maxEventsPerCell;
          html += '<button type="button" class="tatc-ec__chip tatc-ec__chip--more" data-tatc-ec-more="' +
            key + '">' + self.i18n.moreEvents.replace('%count%', more) + '</button>';
        }

        html += '</div></div>';
        cellIndex++;
      }

      while (cellIndex < 42) {
        var nextDay = cellIndex - startOffset - daysInMonth + 1;
        html += '<div class="tatc-ec__day tatc-ec__day--overflow" role="gridcell" aria-hidden="true">' +
          '<span class="tatc-ec__day-num">' + nextDay + '</span></div>';
        cellIndex++;
      }

      this.els.days.innerHTML = html;

      this.els.days.querySelectorAll('.tatc-ec__chip:not(.tatc-ec__chip--closed):not(.tatc-ec__chip--more)').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var eventId = chip.getAttribute('data-event-id');
          var dateKey = chip.getAttribute('data-date');
          var event = self.findEventById(eventId);
          if (event) self.openModal(event, dateKey);
        });
      });

      this.els.days.querySelectorAll('[data-tatc-ec-more]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.view = 'list';
          self.updateViewAttribute();
          self.render();
        });
      });
    };

    TatcEventsCalendar.prototype.getBreakAccent = function (event) {
      return event.color || BREAK_NEUTRAL_ACCENT;
    };

    TatcEventsCalendar.prototype.getCardShowAccent = function (event) {
      return event.color || 'var(--color-primary)';
    };

    TatcEventsCalendar.prototype.getCardShowMapPinSvg = function (size, iconClass) {
      var s = size || 14;
      var cls = iconClass || 'tatc-ec__chip-icon-svg';
      return '<svg class="' + cls + '" width="' + s + '" height="' + s +
        '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>' +
        '<circle cx="12" cy="10" r="3"/></svg>';
    };

    TatcEventsCalendar.prototype.getCardShowClockSvg = function (size) {
      var s = size || 16;
      return '<svg class="tatc-ec__modal-meta-icon" width="' + s + '" height="' + s +
        '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<circle cx="12" cy="12" r="10"/>' +
        '<path d="M12 6v6l4 2"/></svg>';
    };

    TatcEventsCalendar.prototype.getBreakPlatformSvg = function (platform, size) {
      if (platform === 'whatnot') return getWhatnotSvg(size);
      if (platform === 'youtube') return getYoutubeSvg(size);
      return '';
    };

    TatcEventsCalendar.prototype.getBreakChipIcon = function (event) {
      if (event.customIcon) {
        return '<img class="tatc-ec__chip-icon-img" src="' + this.escapeHtml(event.customIcon) + '" alt="" loading="lazy">';
      }
      var svg = this.getBreakPlatformSvg(event.platform, 12);
      if (svg) {
        return '<span class="tatc-ec__chip-icon">' + svg + '</span>';
      }
      return '<span class="tatc-ec__chip-icon"></span>';
    };

    TatcEventsCalendar.prototype.renderChip = function (event, dateKey) {
      var titleAttr = ' title="' + this.escapeHtml(event.title || '') + '"';

      if (event.eventType === 'break') {
        var breakAccent = this.getBreakAccent(event);
        return '<button type="button" class="tatc-ec__chip tatc-ec__chip--break" data-event-id="' + event.id +
          '" data-date="' + dateKey + '"' + titleAttr + ' style="--tatc-ec-chip-accent:' + breakAccent + '">' +
          this.getBreakChipIcon(event) +
          '<span class="tatc-ec__chip-label">' + this.escapeHtml(event.title || '') + '</span></button>';
      }

      if (event.eventType === 'card_show') {
        var cardShowAccent = this.getCardShowAccent(event);
        return '<button type="button" class="tatc-ec__chip tatc-ec__chip--card-show" data-event-id="' + event.id +
          '" data-date="' + dateKey + '"' + titleAttr + ' style="--tatc-ec-chip-accent:' + cardShowAccent + '">' +
          '<span class="tatc-ec__chip-icon tatc-ec__chip-icon--card-show">' + this.getCardShowMapPinSvg(14) + '</span>' +
          '<span class="tatc-ec__chip-label">' + this.escapeHtml(event.title || '') + '</span></button>';
      }

      var label = event.title || '';
      if (event.eventType === 'special') label = '\u2726 ' + label;
      var accent = event.tcg && event.tcg.color ? event.tcg.color : 'var(--color-primary)';
      var chipClass = event.eventType === 'special' ? ' tatc-ec__chip--special' : '';
      return '<button type="button" class="tatc-ec__chip' + chipClass + '" data-event-id="' + event.id +
        '" data-date="' + dateKey + '"' + titleAttr + ' style="--tatc-ec-chip-accent:' + accent + '">' +
        this.escapeHtml(label) + '</button>';
    };

    TatcEventsCalendar.prototype.renderBreakMedia = function (event) {
      if (!event.bannerImage) return '';

      var html = '<div class="tatc-ec__media-wrap">';
      html += '<img class="tatc-ec__banner" src="' + event.bannerImage + '" alt="" loading="lazy">';
      html += '</div>';
      return html;
    };

    TatcEventsCalendar.prototype.renderBreakBodyContent = function (event, dateKey) {
      var html = '<h4 class="tatc-ec__modal-event-title">' + this.escapeHtml(event.title || '') + '</h4>';

      if (event.shortDescription) {
        html += '<p class="tatc-ec__modal-desc">' + this.escapeHtml(event.shortDescription) + '</p>';
      }

      if (event.time) {
        html += '<div class="tatc-ec__modal-meta">';
        html += '<span class="tatc-ec__modal-meta-item"><svg class="tatc-ec__modal-meta-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>' +
          this.escapeHtml(event.time) + '</span>';
        html += '</div>';
      }

      var breakActions = '';
      if (event.streamUrl) {
        var ctaLabel = event.ctaLabel || this.i18n.watchLive || 'Watch Live';
        breakActions += '<a class="button tatc-ec__modal-cta" href="' + this.escapeHtml(event.streamUrl) +
          '" target="_blank" rel="noopener noreferrer">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>' +
          this.escapeHtml(ctaLabel) + '</a>';
      }
      breakActions += this.renderAddToCalendarButton(event, dateKey);
      if (breakActions) {
        html += '<div class="tatc-ec__modal-actions">' + breakActions + '</div>';
      }

      return html;
    };

    TatcEventsCalendar.prototype.renderBreakModalContent = function (event, dateKey) {
      return this.renderBreakMedia(event) + this.renderBreakBodyContent(event, dateKey);
    };

    TatcEventsCalendar.prototype.renderCardShowMedia = function (event) {
      if (!event.bannerImage) return '';

      var html = '<div class="tatc-ec__media-wrap">';
      html += '<img class="tatc-ec__banner" src="' + event.bannerImage + '" alt="" loading="lazy">';
      html += '</div>';
      return html;
    };

    TatcEventsCalendar.prototype.renderCardShowBodyContent = function (event, dateKey) {
      var html = '<h4 class="tatc-ec__modal-event-title">' + this.escapeHtml(event.title || '') + '</h4>';

      if (event.shortDescription) {
        html += '<p class="tatc-ec__modal-desc">' + this.escapeHtml(event.shortDescription) + '</p>';
      }

      if (event.description) {
        html += '<p class="tatc-ec__modal-desc">' + this.escapeHtml(event.description) + '</p>';
      }

      if (event.time) {
        html += '<div class="tatc-ec__modal-meta">';
        html += '<span class="tatc-ec__modal-meta-item">' + this.getCardShowClockSvg(16) +
          this.escapeHtml(event.time) + '</span>';
        html += '</div>';
      }

      var venueParts = [];
      if (event.venueName) venueParts.push(event.venueName);
      if (event.location) venueParts.push(event.location);
      if (venueParts.length) {
        html += '<div class="tatc-ec__modal-meta">';
        html += '<span class="tatc-ec__modal-meta-item">' + this.getCardShowMapPinSvg(16, 'tatc-ec__modal-meta-icon') +
          this.escapeHtml(venueParts.join(' \u00b7 ')) + '</span>';
        html += '</div>';
      }

      var cardShowActions = '';
      if (event.detailUrl) {
        var ctaLabel = event.ctaLabel || this.i18n.getTickets || 'Get Tickets';
        cardShowActions += '<a class="button tatc-ec__modal-cta" href="' + this.escapeHtml(event.detailUrl) + '">' +
          this.escapeHtml(ctaLabel) + '</a>';
      }
      cardShowActions += this.renderAddToCalendarButton(event, dateKey);
      if (cardShowActions) {
        html += '<div class="tatc-ec__modal-actions">' + cardShowActions + '</div>';
      }

      return html;
    };

    TatcEventsCalendar.prototype.renderCardShowModalContent = function (event, dateKey) {
      return this.renderCardShowMedia(event) + this.renderCardShowBodyContent(event, dateKey);
    };

    TatcEventsCalendar.prototype.hasSpecialFlyer = function (event) {
      return !!(event && event.flyerImage);
    };

    TatcEventsCalendar.prototype.hasSplitMedia = function (event) {
      return !!(event && (event.flyerImage || event.bannerImage));
    };

    TatcEventsCalendar.prototype.renderSplitMediaColumn = function (event, options) {
      options = options || {};
      var isSpecial = options.isSpecial;
      var isBreak = options.isBreak;
      var title = event.title || '';
      var html = '<div class="tatc-ec__flyer-media">';

      if (event.flyerImage) {
        html += '<img class="tatc-ec__flyer-image" src="' + event.flyerImage + '" alt="' +
          this.escapeHtml(title) + '" loading="lazy">';
      } else if (event.bannerImage) {
        html += '<img class="tatc-ec__flyer-image tatc-ec__flyer-image--banner" src="' +
          event.bannerImage + '" alt="" loading="lazy">';
      }

      if (event.tcg && event.tcg.logo) {
        html += '<img class="tatc-ec__tcg-logo" src="' + event.tcg.logo + '" alt="' +
          this.escapeHtml(event.tcg.name || '') + '" loading="lazy">';
      }

      if (isSpecial) {
        html += '<span class="tatc-ec__special-badge">\u2726 ' + this.escapeHtml(this.i18n.specialBadge) + '</span>';
      }

      html += '</div>';
      return html;
    };

    TatcEventsCalendar.prototype.renderDesktopListEventBody = function (event, dateKey) {
      return this.renderSplitEventBody(event, dateKey);
    };

    TatcEventsCalendar.prototype.renderSplitEventBody = function (event, dateKey) {
      var isBreak = event.eventType === 'break';
      var isCardShow = event.eventType === 'card_show';
      var isSpecial = event.eventType === 'special';

      if (!this.hasSplitMedia(event)) {
        if (isBreak) {
          return '<article class="tatc-ec__modal-card">' + this.renderBreakModalContent(event, dateKey) + '</article>';
        }
        if (isCardShow) {
          return '<article class="tatc-ec__modal-card">' + this.renderCardShowModalContent(event, dateKey) + '</article>';
        }
        if (isSpecial) {
          return this.renderSpecialStackedContent(event, dateKey);
        }
        var stackedHtml = '<article class="tatc-ec__modal-card">';
        stackedHtml += this.renderEventMedia(event, false);
        stackedHtml += '<h4 class="tatc-ec__modal-event-title">' + this.escapeHtml(event.title || '') + '</h4>';
        stackedHtml += this.renderEventDetailsContent(event, dateKey);
        stackedHtml += '</article>';
        return stackedHtml;
      }

      if (isSpecial && this.hasSpecialFlyer(event)) {
        return this.renderSpecialFlyerContent(event, dateKey);
      }

      var cardClass = 'tatc-ec__modal-card tatc-ec__modal-card--split';
      if (isSpecial) cardClass += ' tatc-ec__modal-card--special';

      var html = '<article class="' + cardClass + '">';
      html += '<div class="tatc-ec__flyer-layout">';
      html += this.renderSplitMediaColumn(event, { isSpecial: isSpecial, isBreak: isBreak });
      html += '<div class="tatc-ec__flyer-content">';

      if (isBreak) {
        html += this.renderBreakBodyContent(event, dateKey);
      } else if (isCardShow) {
        html += this.renderCardShowBodyContent(event, dateKey);
      } else {
        html += '<h4 class="tatc-ec__modal-event-title">' + this.escapeHtml(event.title || '') + '</h4>';
        html += this.renderEventDetailsContent(event, dateKey);
      }

      html += '</div></div></article>';
      return html;
    };

    TatcEventsCalendar.prototype.renderSpecialStackedContent = function (event, dateKey) {
      var html = '<article class="tatc-ec__modal-card tatc-ec__modal-card--special">';
      html += this.renderEventMedia(event, true);
      html += '<h4 class="tatc-ec__modal-event-title">' + this.escapeHtml(event.title || '') + '</h4>';
      html += this.renderEventDetailsContent(event, dateKey);
      html += '</article>';
      return html;
    };

    TatcEventsCalendar.prototype.renderSpecialFlyerContent = function (event, dateKey) {
      var title = event.title || '';
      var html = '<article class="tatc-ec__modal-card tatc-ec__modal-card--special tatc-ec__modal-card--flyer">';
      html += '<div class="tatc-ec__flyer-layout">';
      html += '<div class="tatc-ec__flyer-media">';
      html += '<img class="tatc-ec__flyer-image" src="' + event.flyerImage + '" alt="' +
        this.escapeHtml(title) + '" loading="lazy">';
      html += '<span class="tatc-ec__special-badge">\u2726 ' + this.escapeHtml(this.i18n.specialBadge) + '</span>';
      html += '</div>';
      html += '<div class="tatc-ec__flyer-content">';
      html += '<h4 class="tatc-ec__modal-event-title">' + this.escapeHtml(title) + '</h4>';
      html += this.renderEventDetailsContent(event, dateKey);
      html += '</div>';
      html += '</div>';
      html += '</article>';
      return html;
    };

    TatcEventsCalendar.prototype.renderSpecialModalContent = function (event, dateKey) {
      if (this.hasSpecialFlyer(event)) {
        return this.renderSpecialFlyerContent(event, dateKey);
      }
      return this.renderSpecialStackedContent(event, dateKey);
    };

    TatcEventsCalendar.prototype.renderEventMedia = function (event, isSpecial) {
      if (!event.bannerImage && !(event.tcg && event.tcg.logo)) return '';

      var html = '<div class="tatc-ec__media-wrap">';
      if (event.bannerImage) {
        html += '<img class="tatc-ec__banner" src="' + event.bannerImage + '" alt="" loading="lazy">';
      } else {
        html += '<div class="tatc-ec__banner" role="presentation"></div>';
      }
      if (event.tcg && event.tcg.logo) {
        html += '<img class="tatc-ec__tcg-logo" src="' + event.tcg.logo + '" alt="' +
          this.escapeHtml(event.tcg.name || '') + '" loading="lazy">';
      }
      if (isSpecial) {
        html += '<span class="tatc-ec__special-badge">\u2726 ' + this.escapeHtml(this.i18n.specialBadge) + '</span>';
      }
      html += '</div>';
      return html;
    };

    TatcEventsCalendar.prototype.getEventDescription = function (event) {
      var eventType = event.eventType || event.type || 'recurring';
      var body = event.description || event.shortDescription || '';
      if (!body || eventType !== 'recurring' || !event.tcg || !event.tcg.name) return body;
      if (body.trim().toLowerCase() === event.tcg.name.trim().toLowerCase()) return '';
      return body;
    };

    TatcEventsCalendar.prototype.formatPrizesField = function (value) {
      if (value == null || value === '') return '';

      if (Array.isArray(value)) {
        return value.map(function (item) { return String(item || '').trim(); }).filter(Boolean).join(', ');
      }

      return String(value).trim();
    };

    TatcEventsCalendar.prototype.getEventPrizeLines = function (event) {
      var lines = [];

      if (Array.isArray(event.prizes)) {
        event.prizes.forEach(function (item) {
          var text = String(item || '').trim();
          if (text) lines.push(text);
        });
      } else {
        var prizes = this.formatPrizesField(event.prizes);
        if (prizes) lines.push(prizes);
      }

      var summary = (event.prizesSummary || '').trim();
      if (summary) {
        var combined = lines.join(', ').toLowerCase();
        if (!combined || summary.toLowerCase() !== combined) {
          lines.push(summary);
        }
      }

      return lines;
    };

    TatcEventsCalendar.prototype.renderEventDetailsContent = function (event, dateKey) {
      var html = '';
      var description = this.getEventDescription(event);

      if (event.format) {
        html += '<p class="tatc-ec__modal-format"><span class="tatc-ec__modal-format-label">' +
          this.escapeHtml(this.i18n.formatLabel || 'Format:') + '</span>' +
          '<span class="tatc-ec__modal-format-value">' + this.escapeHtml(event.format) + '</span></p>';
      }

      if (description) {
        html += '<p class="tatc-ec__modal-desc">' + this.escapeHtml(description) + '</p>';
      }

      html += '<div class="tatc-ec__modal-meta">';
      if (event.time) {
        html += '<span class="tatc-ec__modal-meta-item"><svg class="tatc-ec__modal-meta-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>' +
          this.escapeHtml(event.time) + '</span>';
      }
      if (event.entryFee) {
        html += '<span class="tatc-ec__modal-meta-item"><svg class="tatc-ec__modal-meta-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.18 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/></svg>' +
          this.escapeHtml(event.entryFee) + '</span>';
      }
      html += '</div>';

      var prizeLines = this.getEventPrizeLines(event);
      if (prizeLines.length) {
        html += '<div class="tatc-ec__modal-meta"><span class="tatc-ec__modal-meta-item tatc-ec__modal-meta-item--prizes">' +
          '<svg class="tatc-ec__modal-meta-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"/></svg>' +
          '<span class="tatc-ec__modal-meta-prize-lines">';
        prizeLines.forEach(function (line) {
          html += '<span class="tatc-ec__modal-meta-prize-line">' + this.escapeHtml(line) + '</span>';
        }, this);
        html += '</span></span></div>';
      }

      var detailActions = '';
      if (event.detailUrl) {
        var ctaLabel = event.ctaLabel || this.i18n.getTickets || 'Get Tickets';
        detailActions += '<a class="button tatc-ec__modal-cta" href="' + this.escapeHtml(event.detailUrl) + '">' +
          this.escapeHtml(ctaLabel) + '</a>';
      }
      detailActions += this.renderAddToCalendarButton(event, dateKey);
      if (detailActions) {
        html += '<div class="tatc-ec__modal-actions">' + detailActions + '</div>';
      }

      return html;
    };

    TatcEventsCalendar.prototype.renderAddToCalendarButton = function (event, dateKey) {
      var key = dateKey || event.startDate || '';
      if (!event || !event.id || !key) return '';

      var label = this.i18n.addToCalendar || 'Add to calendar';
      return '<button type="button" class="tatc-ec__add-to-calendar" data-tatc-ec-add-cal' +
        ' data-event-id="' + this.escapeHtml(String(event.id)) + '"' +
        ' data-date="' + this.escapeHtml(key) + '">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
        '<path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-7 5h5v5h-5v-5z"/>' +
        '</svg>' +
        '<span>' + this.escapeHtml(label) + '</span></button>';
    };

    TatcEventsCalendar.prototype.getIcsDateRange = function (event, dateKey) {
      var eventType = event.eventType || event.type || 'recurring';
      var startKey;
      var endInclusive;

      if (eventType === 'special' || eventType === 'card_show') {
        startKey = event.startDate || dateKey;
        endInclusive = event.endDate || startKey;
      } else {
        startKey = dateKey || event.startDate;
        endInclusive = startKey;
      }

      if (!startKey) return null;

      return {
        start: toIcsDateValue(startKey),
        end: toIcsDateValue(addDaysToDateKey(endInclusive, 1)),
        uidDate: dateKey || startKey
      };
    };

    TatcEventsCalendar.prototype.buildIcsDescription = function (event) {
      var lines = [];
      var description = this.getEventDescription(event);
      var eventType = event.eventType || event.type || 'recurring';

      if (event.time) lines.push('Time: ' + event.time + ' (Eastern Time)');
      if (event.format) lines.push('Format: ' + event.format);
      if (event.entryFee) lines.push('Entry fee: ' + event.entryFee);
      if (event.shortDescription && event.shortDescription !== description) {
        lines.push(event.shortDescription);
      }
      if (description) lines.push(description);
      if (eventType === 'card_show' && event.description &&
          event.description !== description &&
          event.description !== event.shortDescription) {
        lines.push(event.description);
      }

      var prizeLines = this.getEventPrizeLines(event);
      if (prizeLines.length) {
        lines.push('Prizes: ' + prizeLines.join('; '));
      }

      return lines.join('\n');
    };

    TatcEventsCalendar.prototype.buildIcs = function (event, dateKey) {
      var range = this.getIcsDateRange(event, dateKey);
      if (!range) return '';

      var eventType = event.eventType || event.type || 'recurring';
      var summary = event.title || 'Event';
      var description = this.buildIcsDescription(event);
      var url = event.detailUrl || event.streamUrl || '';
      var location = '';
      var stamp = toIcsDateValue(formatDateKey(new Date())) + 'T000000Z';
      var uid = String(event.id || 'event') + '-' + range.uidDate + '@tatc';

      if (eventType === 'card_show') {
        var venueParts = [];
        if (event.venueName) venueParts.push(event.venueName);
        if (event.location) venueParts.push(event.location);
        location = venueParts.join(', ');
      }

      var lines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//TATC//Events Calendar//EN',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'X-WR-TIMEZONE:America/New_York',
        'BEGIN:VEVENT',
        'UID:' + escapeIcsText(uid),
        'DTSTAMP:' + stamp,
        'DTSTART;VALUE=DATE:' + range.start,
        'DTEND;VALUE=DATE:' + range.end,
        'SUMMARY:' + escapeIcsText(summary)
      ];

      if (description) lines.push('DESCRIPTION:' + escapeIcsText(description));
      if (location) lines.push('LOCATION:' + escapeIcsText(location));
      if (url) lines.push('URL:' + escapeIcsText(url));

      lines.push('END:VEVENT', 'END:VCALENDAR');
      return lines.join('\r\n');
    };

    TatcEventsCalendar.prototype.downloadIcs = function (event, dateKey) {
      var ics = this.buildIcs(event, dateKey);
      if (!ics) return;

      var safeName = String(event.title || 'event')
        .replace(/[^\w\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .slice(0, 40) || 'event';
      var blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = safeName + '.ics';
      link.setAttribute('download', safeName + '.ics');
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      window.setTimeout(function () {
        if (link.parentNode) link.parentNode.removeChild(link);
        URL.revokeObjectURL(url);
      }, 1500);
    };

    TatcEventsCalendar.prototype.renderEventAccordionCard = function (event, options) {
      options = options || {};
      var dateKey = options.dateKey || '';
      var isDesktopList = options.variant === 'desktop-list';
      var isBreak = event.eventType === 'break';
      var isCardShow = event.eventType === 'card_show';
      var isSpecial = event.eventType === 'special';
      var prefix = isSpecial ? '\u2726 ' : '';
      var html = '<details class="tatc-ec__event-accordion' +
        (isSpecial ? ' tatc-ec__event-accordion--special' : '') +
        (isDesktopList ? ' tatc-ec__event-accordion--desktop-list' : '') + '">';
      html += '<summary class="tatc-ec__event-accordion-summary">';
      html += '<div class="tatc-ec__event-accordion-summary-text">';
      html += '<p class="tatc-ec__event-accordion-title">' + this.escapeHtml(prefix + (event.title || '')) + '</p>';

      if (isDesktopList && event.time) {
        html += '<div class="tatc-ec__event-accordion-meta">';
        html += '<span class="tatc-ec__event-accordion-meta-item">' + this.escapeHtml(event.time) + '</span>';
        html += '</div>';
      } else if (event.time) {
        html += '<p class="tatc-ec__event-accordion-time">' + this.escapeHtml(event.time) + '</p>';
      }

      html += '</div>';
      html += '<svg class="tatc-ec__event-accordion-chevron" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"/></svg>';
      html += '</summary>';
      html += '<div class="tatc-ec__event-accordion-body">';
      if (isDesktopList) {
        html += this.renderDesktopListEventBody(event, dateKey);
      } else if (isBreak) {
        html += this.renderBreakModalContent(event, dateKey);
      } else if (isCardShow) {
        html += this.renderCardShowModalContent(event, dateKey);
      } else if (isSpecial) {
        html += this.renderSpecialModalContent(event, dateKey);
      } else {
        html += this.renderEventMedia(event, isSpecial);
        html += this.renderEventDetailsContent(event, dateKey);
      }
      html += '</div></details>';
      return html;
    };

    TatcEventsCalendar.prototype.getClosedLabel = function (closed) {
      if (!closed) return '';
      var label = this.i18n.closed || 'Closed';
      if (closed.reason) {
        label = (this.i18n.closedReason || 'Closed — %reason%').replace('%reason%', closed.reason);
      }
      return label;
    };

    TatcEventsCalendar.prototype.renderMobileAgenda = function () {
      this.renderMobileWeekNav();
      this.renderMobileFilters();

      if (!this.els.mobileAgenda) return;

      var self = this;
      var html = '';
      var emptyDayMsg = this.i18n.emptyDay || 'Sorry, no events scheduled for today — check back soon.';
      var emptyWeekMsg = this.i18n.noEventsWeek || 'No events scheduled for this week.';
      var weekDates = this.getMobileWeekDates();
      var hasAnyContent = false;
      var dayBlocks = '';

      if (!weekDates.length) {
        this.els.mobileAgenda.innerHTML = '<p class="tatc-ec__empty">' + this.escapeHtml(emptyWeekMsg) + '</p>';
        return;
      }

      weekDates.forEach(function (date) {
        var key = formatDateKey(date);
        var raw = self.getRawEventsForDate(key);
        var events = self.applyMobileFilter(raw.events);
        var dateLabel = date.toLocaleDateString(undefined, {
          weekday: 'long', month: 'long', day: 'numeric'
        });

        if (events.length || raw.closed) {
          hasAnyContent = true;
        }

        dayBlocks += '<div class="tatc-ec__list-group"><h4 class="tatc-ec__list-group-title">' +
          self.escapeHtml(dateLabel) + '</h4>';

        if (raw.closed) {
          dayBlocks += '<p class="tatc-ec__mobile-closed">' +
            self.escapeHtml(self.getClosedLabel(raw.closed)) + '</p>';
        }

        if (events.length) {
          dayBlocks += '<div class="tatc-ec__list-cards">';
          events.forEach(function (e) {
            dayBlocks += self.renderEventAccordionCard(e, { dateKey: key });
          });
          dayBlocks += '</div>';
        } else if (!raw.closed) {
          dayBlocks += '<p class="tatc-ec__mobile-empty">' + self.escapeHtml(emptyDayMsg) + '</p>';
        }

        dayBlocks += '</div>';
      });

      if (!hasAnyContent) {
        html = '<p class="tatc-ec__empty">' + this.escapeHtml(emptyWeekMsg) + '</p>';
      } else {
        html = dayBlocks;
      }

      this.els.mobileAgenda.innerHTML = html;
    };

    TatcEventsCalendar.prototype.renderList = function () {
      if (!this.els.listView) return;

      var self = this;
      var groups = [];
      var daysInMonth = new Date(this.year, this.month + 1, 0).getDate();
      var todayKey = formatDateKey(this.today);
      var isCurrentMonth = this.year === this.today.getFullYear() && this.month === this.today.getMonth();

      for (var d = 1; d <= daysInMonth; d++) {
        var date = new Date(this.year, this.month, d);
        var key = formatDateKey(date);
        if (isCurrentMonth && key < todayKey) continue;

        var data = this.getEventsForDate(key);
        if (data.events.length) {
          groups.push({ date: date, key: key, events: data.events });
        }
      }

      if (!groups.length) {
        var emptyMsg = this.i18n.noEventsMonth || this.i18n.noEvents || 'No events scheduled for this month.';
        this.els.listView.innerHTML = '<p class="tatc-ec__empty">' + this.escapeHtml(emptyMsg) + '</p>';
        return;
      }

      var html = '';
      groups.forEach(function (group) {
        var dateLabel = group.date.toLocaleDateString(undefined, {
          weekday: 'long', month: 'long', day: 'numeric'
        });
        html += '<div class="tatc-ec__list-group"><h4 class="tatc-ec__list-group-title">' +
          self.escapeHtml(dateLabel) + '</h4><div class="tatc-ec__list-cards">';

        group.events.forEach(function (e) {
          html += self.renderEventAccordionCard(e, { variant: 'desktop-list', dateKey: group.key });
        });

        html += '</div></div>';
      });

      this.els.listView.innerHTML = html;
    };

    TatcEventsCalendar.prototype.findEventById = function (id) {
      var found = null;
      var eventType = 'recurring';
      var idStr = String(id == null ? '' : id);

      this.recurring.forEach(function (e) {
        if (String(e.id) === idStr) {
          found = e;
          eventType = 'recurring';
        }
      });

      this.special.forEach(function (e) {
        if (String(e.id) === idStr) {
          found = e;
          eventType = 'special';
        }
      });

      this.breaks.forEach(function (e) {
        if (String(e.id) === idStr) {
          found = e;
          eventType = 'break';
        }
      });

      this.cardShows.forEach(function (e) {
        if (String(e.id) === idStr) {
          found = e;
          eventType = 'card_show';
        }
      });

      if (found) {
        return Object.assign({}, found, { eventType: eventType });
      }
      return null;
    };

    TatcEventsCalendar.prototype.openModal = function (event, dateKey) {
      if (this.isMobile || !this.els.modal) return;

      var date = parseDateKey(dateKey);
      var dateLabel = date.toLocaleDateString(undefined, {
        weekday: 'long', month: 'long', day: 'numeric'
      });
      var allOnDay = this.getEventsForDate(dateKey, false);
      var countLabel = allOnDay.events.length === 1
        ? (this.i18n.eventCountOne || '1 event')
        : (this.i18n.eventCountOther || '').replace('%count%', allOnDay.events.length);

      this.els.modalDate.textContent = dateLabel;
      this.els.modalCount.textContent = countLabel;

      var eventType = event.eventType || event.type || 'recurring';
      var html;
      var modalPanel = this.els.modal.querySelector('.tatc-ec__modal-panel');

      html = this.renderSplitEventBody(event, dateKey);

      if (modalPanel) {
        modalPanel.classList.toggle('tatc-ec__modal-panel--flyer', this.hasSplitMedia(event));
      }

      this.els.modalBody.innerHTML = html;

      var mediaWrap = this.els.modalBody.querySelector('.tatc-ec__media-wrap, .tatc-ec__flyer-media');
      if (mediaWrap) mediaWrap.classList.remove('is-logo-visible');

      if (typeof this.els.modal.showModal === 'function') {
        this.els.modal.classList.remove('dialog-closing');
        this.els.modal.showModal();
      } else {
        this.els.modal.classList.remove('dialog-closing');
        this.els.modal.setAttribute('open', '');
      }

      if (mediaWrap) {
        window.requestAnimationFrame(function () {
          mediaWrap.classList.add('is-logo-visible');
        });
      }

      document.documentElement.classList.add('tatc-ec-modal-open');
    };

    TatcEventsCalendar.prototype._finishCloseModal = function () {
      if (!this.els.modal) return;

      var mediaWrap = this.els.modalBody && this.els.modalBody.querySelector('.tatc-ec__media-wrap, .tatc-ec__flyer-media');
      if (mediaWrap) mediaWrap.classList.remove('is-logo-visible');

      var modalPanel = this.els.modal.querySelector('.tatc-ec__modal-panel');
      if (modalPanel) modalPanel.classList.remove('tatc-ec__modal-panel--flyer');

      this.els.modal.classList.remove('dialog-closing');
      this._modalClosing = false;

      if (this.els.modal.open) {
        this.els.modal.close();
      } else {
        this.els.modal.removeAttribute('open');
      }

      document.documentElement.classList.remove('tatc-ec-modal-open');
    };

    TatcEventsCalendar.prototype.closeModal = function () {
      if (!this.els.modal || !this.els.modal.open || this._modalClosing) return;

      var modalAnimOn = this.els.modal.getAttribute('data-tatc-ec-modal-anim') === 'on';

      if (prefersReducedMotion() || this.isMobile || !modalAnimOn) {
        this._finishCloseModal();
        return;
      }

      var self = this;
      var modal = this.els.modal;
      var panel = modal.querySelector('.tatc-ec__modal-panel');

      this._modalClosing = true;
      modal.classList.add('dialog-closing');

      if (!panel) {
        this._finishCloseModal();
        return;
      }

      var finished = false;
      var finish = function () {
        if (finished) return;
        finished = true;
        panel.removeEventListener('animationend', onAnimationEnd);
        self._finishCloseModal();
      };

      var onAnimationEnd = function (event) {
        if (event.target === panel) finish();
      };

      panel.addEventListener('animationend', onAnimationEnd);
      window.setTimeout(finish, 500);
    };

    TatcEventsCalendar.prototype.escapeHtml = function (str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    };

    TatcEventsCalendar.prototype.render = function () {
      this.isMobile = isMobileViewport();
      this.root.setAttribute(
        'data-tatc-ec-layout',
        this.isMobile ? 'mobile' : (supportsGridView() ? 'desktop' : 'tablet')
      );

      if (this.isMobile) {
        this.renderMobileAgenda();
        this._hasRendered = true;
        return;
      }

      if (this.els.monthLabel) {
        this.els.monthLabel.textContent = MONTHS[this.month] + ' ' + this.year;
      }
      if (this.els.prevBtn) this.els.prevBtn.disabled = !this.canGoPrev();
      if (this.els.nextBtn) this.els.nextBtn.disabled = !this.canGoNext();

      this.renderFilters();
      this.renderLegend();

      var activeView = this.getActiveView();
      if (activeView === 'grid') {
        this.renderGrid();
      } else {
        this.renderList();
      }

      if (this._hasRendered) {
        this.playMonthTransition();
      }
      this._hasRendered = true;
    };

    TatcEventsCalendar.prototype.revealSection = function () {
      this.root.classList.add('is-visible');
    };

    TatcEventsCalendar.prototype.shouldAnimateMonth = function () {
      if (this.root.getAttribute('data-tatc-ec-anim') !== 'on') return false;
      if (this.root.getAttribute('data-tatc-ec-month-transition') !== 'true') return false;
      if (prefersReducedMotion()) return false;
      if (this.isMobile) return false;
      if (this.root.getAttribute('data-tatc-ec-anim-desktop-only') === 'true' && this.isMobile) return false;
      return true;
    };

    TatcEventsCalendar.prototype.playMonthTransition = function () {
      if (!this.shouldAnimateMonth()) return;

      var targets = [];

      if (this.getActiveView() === 'grid' && this.els.days) {
        this.els.days.querySelectorAll('.tatc-ec__day:not(.tatc-ec__day--overflow)').forEach(function (day, index) {
          day.classList.remove('is-month-visible', 'tatc-ec__month-reveal');
          day.style.setProperty('--tatc-ec-anim-index', Math.floor(index / 7));
          day.classList.add('tatc-ec__month-reveal');
          targets.push(day);
        });
      } else if (this.getActiveView() === 'list' && this.els.listView) {
        this.els.listView.querySelectorAll('.tatc-ec__list-group').forEach(function (group, index) {
          group.classList.remove('is-month-visible', 'tatc-ec__month-reveal');
          group.style.setProperty('--tatc-ec-anim-index', index);
          group.classList.add('tatc-ec__month-reveal');
          targets.push(group);
        });
      }

      if (!targets.length) return;

      window.requestAnimationFrame(function () {
        targets.forEach(function (el) { el.classList.add('is-month-visible'); });
      });
    };

    TatcEventsCalendar.prototype.initAnimations = function () {
      var animOn = this.root.getAttribute('data-tatc-ec-anim') === 'on';
      var desktopOnly = this.root.getAttribute('data-tatc-ec-anim-desktop-only') === 'true';

      if (!animOn || prefersReducedMotion() || (desktopOnly && this.isMobile)) {
        this.revealSection();
        return;
      }

      var trigger = this.root.getAttribute('data-tatc-ec-trigger') || 'scroll';

      if (trigger === 'page-load') {
        this.revealSection();
        return;
      }

      if (!('IntersectionObserver' in window)) {
        this.revealSection();
        return;
      }

      var self = this;
      this._animObserver = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          self.revealSection();
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -48px 0px' });

      this._animObserver.observe(this.root);
    };

    TatcEventsCalendar.prototype.destroy = function () {
      if (this._abortController) this._abortController.abort();
      if (this._animObserver) this._animObserver.disconnect();
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      this.root.classList.remove('is-visible');
      this.closeModal();
      if (this.els.modal && this.els.modal.parentElement === document.body) {
        this.els.modal.remove();
      }
    };

    var instances = new WeakMap();

    function initRoot(root) {
      if (!root) return;
      destroyRoot(root);
      instances.set(root, new TatcEventsCalendar(root));
    }

    function destroyRoot(root) {
      var inst = instances.get(root);
      if (inst) {
        inst.destroy();
        instances.delete(root);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-tatc-ec-root]').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = document.querySelector('[data-tatc-ec-root][data-section-id="' + e.detail.sectionId + '"]');
      if (root) {
        destroyRoot(root);
        initRoot(root);
      }
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var root = document.querySelector('[data-tatc-ec-root][data-section-id="' + e.detail.sectionId + '"]');
      if (root) destroyRoot(root);
    });

    document.addEventListener('shopify:section:select', function (e) {
      var root = e.target.querySelector('[data-tatc-ec-root]');
      if (root) root.classList.add('is-visible');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tatc-events"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var DAY_ORDER = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    var REGULARS_BULLET =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="5"/></svg>';

    var ICONS = {
      clock: '<svg class="tatc-he__card-meta-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>',
      dollar: '<svg class="tatc-he__card-meta-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.18 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/></svg>',
      trophy: '<svg class="tatc-he__card-meta-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"/></svg>'
    };

    function parseJsonScript(id, fallback) {
      var el = document.getElementById(id);
      if (!el || !el.textContent) return fallback !== undefined ? fallback : [];
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return fallback !== undefined ? fallback : [];
      }
    }

    function formatDateKey(date) {
      var y = date.getFullYear();
      var m = String(date.getMonth() + 1).padStart(2, '0');
      var d = String(date.getDate()).padStart(2, '0');
      return y + '-' + m + '-' + d;
    }

    function parseDateKey(key) {
      var parts = key.split('-');
      return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    }

    function formatShortDate(dateKey) {
      if (!dateKey) return '';
      return parseDateKey(dateKey).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    }

    function escapeHtml(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function trimText(value) {
      if (value == null) return '';
      return String(value).trim();
    }

    function formatListField(value) {
      if (value == null || value === '') return '';

      if (Array.isArray(value)) {
        return value.map(function (item) { return trimText(item); }).filter(Boolean).join(', ');
      }

      var text = trimText(value);
      if (!text) return '';

      if (text.charAt(0) === '[' && text.charAt(text.length - 1) === ']') {
        try {
          var parsed = JSON.parse(text);
          if (Array.isArray(parsed)) {
            return parsed.map(function (item) { return trimText(item); }).filter(Boolean).join(', ');
          }
        } catch (e) {
          /* fall through to plain text cleanup */
        }
      }

      return text;
    }

    function getCardDescription(event) {
      var desc = trimText(event.description);
      if (!desc) return '';
      if (trimText(event.title).toLowerCase() === desc.toLowerCase()) return '';
      return desc;
    }

    function renderMetaItem(icon, text, clamp) {
      var textClass = clamp ? ' tatc-he__card-meta-text--clamp' : '';
      return '<span class="tatc-he__card-meta-item">' + icon +
        '<span class="tatc-he__card-meta-text' + textClass + '">' + escapeHtml(text) + '</span></span>';
    }

    function renderMetaItemMulti(icon, texts, clamp) {
      var textClass = clamp ? ' tatc-he__card-meta-text--clamp' : '';
      var inner = texts.map(function (text) {
        return '<span class="tatc-he__card-meta-text' + textClass + '">' + escapeHtml(text) + '</span>';
      }).join('');
      return '<span class="tatc-he__card-meta-item">' + icon +
        '<span class="tatc-he__card-meta-texts">' + inner + '</span></span>';
    }

    function renderMetaRow(items) {
      if (!items.length) return '';
      return '<div class="tatc-he__card-meta">' + items.join('') + '</div>';
    }

    function renderCardPreviewDetails(event) {
      var html = '';
      var format = trimText(event.format);
      var description = getCardDescription(event);
      var time = trimText(event.time);
      var entryFee = trimText(event.entryFee);
      var prizes = formatListField(event.prizes);
      var prizesSummary = trimText(event.prizesSummary);
      var metaItems = [];

      if (format) {
        html += '<p class="tatc-he__card-format"><span class="tatc-he__card-format-label">Format:</span> ' +
          escapeHtml(format) + '</p>';
      }

      if (description) {
        html += '<p class="tatc-he__card-desc">' + escapeHtml(description) + '</p>';
      }

      if (time) metaItems.push(renderMetaItem(ICONS.clock, time));
      if (entryFee) metaItems.push(renderMetaItem(ICONS.dollar, entryFee));
      html += renderMetaRow(metaItems);

      var prizeTexts = [];
      if (prizes) prizeTexts.push(prizes);
      if (prizesSummary && prizesSummary.toLowerCase() !== prizes.toLowerCase()) {
        prizeTexts.push(prizesSummary);
      }
      if (prizeTexts.length) {
        html += renderMetaRow([renderMetaItemMulti(ICONS.trophy, prizeTexts, true)]);
      }

      return html;
    }

    function TatcHomepageEvents(root) {
      this.root = root;
      this.sectionId = root.getAttribute('data-section-id');
      this.zone1Enabled = root.getAttribute('data-zone1-enabled') === 'true';
      this.zone2Enabled = root.getAttribute('data-zone2-enabled') === 'true';
      this.carouselEnabled = root.getAttribute('data-carousel-enabled') === 'true';
      this.maxEvents = parseInt(root.getAttribute('data-max-events'), 10) || 3;
      this._carouselScrollRaf = null;
      this._carouselResizeTimer = null;
      this._onCarouselScroll = null;
      this._onCarouselResize = null;
      this._onCarouselPrev = null;
      this._onCarouselNext = null;
      this._carouselRevealObserver = null;

      this.els = {
        zone1: root.querySelector('[data-tatc-he-zone1]'),
        zone2: root.querySelector('[data-tatc-he-zone2]'),
        cards: root.querySelector('[data-tatc-he-cards]'),
        nav: root.querySelector('[data-tatc-he-nav]'),
        prev: root.querySelector('[data-tatc-he-prev]'),
        next: root.querySelector('[data-tatc-he-next]'),
        regularsList: root.querySelector('[data-tatc-he-regulars-list]')
      };

      this.render();
    }

    TatcHomepageEvents.prototype.teardownCarousel = function () {
      var track = this.els.cards;
      var nav = this.els.nav;

      if (this._onCarouselScroll && track) {
        track.removeEventListener('scroll', this._onCarouselScroll);
      }
      if (this._onCarouselResize) {
        window.removeEventListener('resize', this._onCarouselResize);
      }
      if (this._onCarouselPrev && this.els.prev) {
        this.els.prev.removeEventListener('click', this._onCarouselPrev);
      }
      if (this._onCarouselNext && this.els.next) {
        this.els.next.removeEventListener('click', this._onCarouselNext);
      }
      if (this._carouselScrollRaf) {
        cancelAnimationFrame(this._carouselScrollRaf);
        this._carouselScrollRaf = null;
      }
      if (this._carouselResizeTimer) {
        clearTimeout(this._carouselResizeTimer);
        this._carouselResizeTimer = null;
      }
      if (this._carouselRevealObserver) {
        this._carouselRevealObserver.disconnect();
        this._carouselRevealObserver = null;
      }

      this._onCarouselScroll = null;
      this._onCarouselResize = null;
      this._onCarouselPrev = null;
      this._onCarouselNext = null;

      if (this.els.zone1) {
        this.els.zone1.removeAttribute('data-carousel-active');
      }
      if (nav) {
        nav.setAttribute('hidden', '');
      }
      if (track) {
        track.removeAttribute('tabindex');
        track.removeAttribute('aria-label');
      }
      if (this.els.prev) this.els.prev.disabled = false;
      if (this.els.next) this.els.next.disabled = false;
    };

    TatcHomepageEvents.prototype.syncCarouselNav = function () {
      var track = this.els.cards;
      if (!track || !this.els.prev || !this.els.next) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScroll - 2;

      this.els.prev.disabled = atStart || maxScroll <= 0;
      this.els.next.disabled = atEnd || maxScroll <= 0;
    };

    TatcHomepageEvents.prototype.getCarouselStep = function () {
      var track = this.els.cards;
      if (!track) return 0;
      var wraps = track.querySelectorAll('.tatc-he__card-wrap');
      if (wraps.length < 2) {
        return wraps[0] ? wraps[0].offsetWidth : 0;
      }
      return wraps[1].offsetLeft - wraps[0].offsetLeft;
    };

    TatcHomepageEvents.prototype.scrollCarouselBy = function (direction) {
      var track = this.els.cards;
      if (!track) return;
      var step = this.getCarouselStep();
      if (!step) return;

      var behavior = 'smooth';
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        behavior = 'auto';
      }

      track.scrollBy({ left: direction * step, behavior: behavior });
    };

    TatcHomepageEvents.prototype.setupCarouselReveal = function () {
      var track = this.els.cards;
      if (!track || typeof IntersectionObserver === 'undefined') {
        if (track) {
          track.querySelectorAll('.tatc-he__card-wrap.animate-on-scroll').forEach(function (el) {
            el.classList.add('is-visible');
          });
        }
        return;
      }

      var self = this;
      if (this._carouselRevealObserver) {
        this._carouselRevealObserver.disconnect();
      }

      this._carouselRevealObserver = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            track.querySelectorAll('.tatc-he__card-wrap.animate-on-scroll').forEach(function (el) {
              el.classList.add('is-visible');
            });
            obs.unobserve(entry.target);
            self._carouselRevealObserver = null;
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -12% 0px' }
      );

      this._carouselRevealObserver.observe(track);
    };

    TatcHomepageEvents.prototype.setupCarousel = function (count) {
      this.teardownCarousel();

      var shouldActivate = this.carouselEnabled && count > 3;
      if (!shouldActivate || !this.els.zone1 || !this.els.cards) return;

      var track = this.els.cards;
      var nav = this.els.nav;
      var self = this;

      this.els.zone1.setAttribute('data-carousel-active', '');
      if (nav) nav.removeAttribute('hidden');

      track.setAttribute('tabindex', '0');
      track.setAttribute('aria-label', 'Special events carousel');

      this._onCarouselPrev = function () {
        self.scrollCarouselBy(-1);
      };
      this._onCarouselNext = function () {
        self.scrollCarouselBy(1);
      };

      if (this.els.prev) this.els.prev.addEventListener('click', this._onCarouselPrev);
      if (this.els.next) this.els.next.addEventListener('click', this._onCarouselNext);

      this._onCarouselScroll = function () {
        if (self._carouselScrollRaf) return;
        self._carouselScrollRaf = requestAnimationFrame(function () {
          self._carouselScrollRaf = null;
          self.syncCarouselNav();
        });
      };
      track.addEventListener('scroll', this._onCarouselScroll, { passive: true });

      this._onCarouselResize = function () {
        clearTimeout(self._carouselResizeTimer);
        self._carouselResizeTimer = setTimeout(function () {
          self.syncCarouselNav();
        }, 150);
      };
      window.addEventListener('resize', this._onCarouselResize);

      this.syncCarouselNav();
      this.setupCarouselReveal();
    };

    TatcHomepageEvents.prototype.renderZone1 = function () {
      if (!this.zone1Enabled || !this.els.zone1 || !this.els.cards) return;

      var special = parseJsonScript('homepage-special-events-' + this.sectionId, []);
      var todayKey = formatDateKey(new Date());
      var root = this.root;
      var animOn = root.getAttribute('data-anim-on') === 'true';
      var itemAnim = root.getAttribute('data-item-anim') || 'fade-up';
      var useStagger = root.getAttribute('data-use-stagger') === 'true';
      var animDuration = root.getAttribute('data-anim-duration') || '400';
      var animDelay = root.getAttribute('data-anim-delay') || '0';
      var maxEvents = this.maxEvents;

      var upcoming = special
        .filter(function (e) {
          return e.isActive && e.startDate && e.startDate >= todayKey;
        })
        .sort(function (a, b) {
          return a.startDate.localeCompare(b.startDate);
        })
        .slice(0, maxEvents);

      if (!upcoming.length) {
        this.teardownCarousel();
        this.els.zone1.setAttribute('hidden', '');
        this.els.cards.innerHTML = '';
        return;
      }

      var html = upcoming.map(function (event, index) {
        var badge = formatShortDate(event.startDate);
        var title = event.title || '';
        var alt = title ? escapeHtml(title) : '';

        var wrapStyle = '';
        var wrapClass = 'tatc-he__card-wrap';
        var wrapAttrs = 'role="listitem"';

        if (animOn) {
          wrapClass += ' animate-on-scroll';
          wrapAttrs += ' data-animation="' + escapeHtml(itemAnim) + '"';
          wrapStyle = '--animation-duration: ' + animDuration + 'ms; --animation-delay: ' + animDelay + 'ms;';
          if (useStagger) {
            wrapStyle += ' --animation-order: ' + index + ';';
          }
        }

        var card = '<div class="' + wrapClass + '" ' + wrapAttrs;
        if (wrapStyle) {
          card += ' style="' + wrapStyle + '"';
        }
        card += '>';
        card += '<article class="tatc-he__card">';
        card += '<div class="tatc-he__card-media">';

        if (event.bannerImage) {
          card += '<img class="tatc-he__card-image" src="' + escapeHtml(event.bannerImage) + '" alt="' + alt + '" loading="lazy" width="1200" height="675">';
        } else {
          card += '<div class="tatc-he__card-placeholder" role="presentation"></div>';
          if (event.tcg && event.tcg.logo) {
            var logoAlt = event.tcg.name ? escapeHtml(event.tcg.name) : '';
            card += '<img class="tatc-he__tcg-logo" src="' + escapeHtml(event.tcg.logo) + '" alt="' + logoAlt + '" loading="lazy" width="400" height="400">';
          }
        }

        if (badge) {
          card += '<span class="tatc-he__date-badge">' + escapeHtml(badge) + '</span>';
        }

        card += '</div>';
        card += '<div class="tatc-he__card-body">';

        if (title) {
          card += '<h3 class="tatc-he__card-title">' + escapeHtml(title) + '</h3>';
        }

        card += renderCardPreviewDetails(event);
        card += '</div>';

        if (event.detailUrl) {
          var ctaLabel = event.ctaLabel || 'Learn more';
          card += '<div class="tatc-he__card-footer">';
          card += '<a class="button tatc-he__card-cta" href="' + escapeHtml(event.detailUrl) + '">' +
            escapeHtml(ctaLabel) + '</a>';
          card += '</div>';
        }

        card += '</article></div>';
        return card;
      }).join('');

      this.els.cards.innerHTML = html;
      this.els.zone1.removeAttribute('hidden');
      this.setupCarousel(upcoming.length);
    };

    function renderRegularsItem(event, index, animOpts) {
      var label = event.title || '';
      if (!label) return '';

      var textHtml = event.detailUrl
        ? '<a class="tatc-he__regulars-link" href="' + escapeHtml(event.detailUrl) + '">' + escapeHtml(label) + '</a>'
        : '<span class="tatc-he__regulars-text">' + escapeHtml(label) + '</span>';

      var itemClass = 'tatc-he__regulars-item';
      var itemAttrs = '';
      var itemStyle = '';

      if (animOpts && animOpts.animOn) {
        itemClass += ' animate-on-scroll';
        itemAttrs += ' data-animation="' + escapeHtml(animOpts.itemAnim) + '"';
        itemStyle = '--animation-duration: ' + animOpts.animDuration + 'ms; --animation-delay: ' + animOpts.animDelay + 'ms;';
        if (animOpts.useStagger) {
          itemStyle += ' --animation-order: ' + index + ';';
        }
      }

      var html = '<li class="' + itemClass + '"' + itemAttrs;
      if (itemStyle) {
        html += ' style="' + itemStyle + '"';
      }
      html += '>' +
        '<span class="tatc-he__regulars-icon" aria-hidden="true">' + REGULARS_BULLET + '</span>' +
        textHtml + '</li>';
      return html;
    }

    TatcHomepageEvents.prototype.renderZone2 = function () {
      if (!this.zone2Enabled || !this.els.zone2 || !this.els.regularsList) return;

      var recurring = parseJsonScript('homepage-recurring-events-' + this.sectionId, []);
      var root = this.root;
      var animOpts = {
        animOn: root.getAttribute('data-anim-on') === 'true',
        itemAnim: root.getAttribute('data-item-anim') || 'fade-up',
        useStagger: root.getAttribute('data-use-stagger') === 'true',
        animDuration: root.getAttribute('data-anim-duration') || '400',
        animDelay: root.getAttribute('data-anim-delay') || '0'
      };

      var regulars = recurring
        .filter(function (e) {
          return e.isActive && e.tcg && (e.tcg.name || e.tcg.slug);
        })
        .sort(function (a, b) {
          var aIdx = DAY_ORDER.indexOf(a.dayOfWeek);
          var bIdx = DAY_ORDER.indexOf(b.dayOfWeek);
          if (aIdx === -1) aIdx = 99;
          if (bIdx === -1) bIdx = 99;
          if (aIdx !== bIdx) return aIdx - bIdx;
          return (a.title || '').localeCompare(b.title || '');
        });

      if (!regulars.length) {
        this.els.zone2.setAttribute('hidden', '');
        this.els.regularsList.innerHTML = '';
        return;
      }

      this.els.regularsList.innerHTML = regulars.map(function (event, index) {
        return renderRegularsItem(event, index, animOpts);
      }).join('');
      this.els.zone2.removeAttribute('hidden');
    };

    TatcHomepageEvents.prototype.render = function () {
      this.renderZone1();
      this.renderZone2();
      if (typeof window.initScrollAnimations === 'function') {
        window.initScrollAnimations(this.root);
      }
    };

    TatcHomepageEvents.prototype.destroy = function () {
      this.teardownCarousel();
      if (this.els.cards) this.els.cards.innerHTML = '';
      if (this.els.regularsList) this.els.regularsList.innerHTML = '';
      if (this.els.zone1) this.els.zone1.setAttribute('hidden', '');
      if (this.els.zone2) this.els.zone2.setAttribute('hidden', '');
    };

    var instances = new WeakMap();

    function initRoot(root) {
      if (!root || instances.has(root)) return;
      instances.set(root, new TatcHomepageEvents(root));
    }

    function destroyRoot(root) {
      var inst = instances.get(root);
      if (inst) {
        inst.destroy();
        instances.delete(root);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-tatc-he-root]').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = document.querySelector('[data-tatc-he-root][data-section-id="' + e.detail.sectionId + '"]');
      if (root) {
        destroyRoot(root);
        initRoot(root);
      }
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var root = document.querySelector('[data-tatc-he-root][data-section-id="' + e.detail.sectionId + '"]');
      if (root) destroyRoot(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tatc-giveaway"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion =
      window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
      !document.documentElement.classList.contains('shopify-design-mode');

    function revealPageLoad(root) {
      if (!root) return;
      if (root.getAttribute('data-tatc-giveaway-anim') !== 'on') return;
      if (root.getAttribute('data-tatc-giveaway-trigger') !== 'page-load') return;
      root.querySelectorAll('.animate-on-scroll').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    function settle(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      root.querySelectorAll('[data-tatc-giveaway-root]').forEach(function (section) {
        revealPageLoad(section);
        if (!reduceMotion) return;
        section.querySelectorAll('[data-tatc-giveaway-card] video').forEach(function (video) {
          if (video.dataset.giveawaySettled === 'true') return;
          video.dataset.giveawaySettled = 'true';
          var button = video.closest('[data-tatc-giveaway-card]').querySelector('[data-tatc-giveaway-pause]');
          var stop = function () {
            video.pause();
            if (!button) return;
            button.dataset.paused = 'true';
            button.setAttribute('aria-label', button.dataset.playLabel || 'Play video');
          };
          stop();
          video.addEventListener('loadeddata', stop, { once: true });
        });
      });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-tatc-giveaway-pause]');
      if (!button) return;
      var card = button.closest('[data-tatc-giveaway-card]');
      var video = card && card.querySelector('video');
      if (!video) return;
      if (video.paused) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
        button.dataset.paused = 'false';
        button.setAttribute('aria-label', button.dataset.pauseLabel || 'Pause video');
      } else {
        video.pause();
        button.dataset.paused = 'true';
        button.setAttribute('aria-label', button.dataset.playLabel || 'Play video');
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        settle(document);
      });
    } else {
      settle(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      settle(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
